<ng-container *ngIf="currentUser$ | async as currentUser">
    <ng-template #closingTemplate let-showAll="showAll">
        <app-fcp-card
            icon="assets/hamIcons/file-check-outline.svg"
            title="{{ 'aumico_reports_closing_entries_title' | i18next }}{{
                activeTestItem?.name ? ': ' + activeTestItem.name : ''
            }}"
            hasOtherYear="true"
            [hasAddButton]="!showAll"
            addButtonText="{{ 'aumico_reports_fcp_closing_add_entry' | i18next }}"
            [expanded]="cardExpandedState['closing']"
            (expandedChange)="updateCardExpandedState('closing', $event)"
            (onAdd)="handleAddClosingEntry()"
        >
            <app-fcp-closing-entries
                #closingEntries
                [currentUser]="currentUser"
                [dueDates]="dueDates"
                [domainModel]="domainModel"
                [showAll]="showAll"
            ></app-fcp-closing-entries>
            <app-fcp-closing-entries
                lastYear
                [lastYear]="true"
                [currentUser]="currentUser"
                [dueDates]="dueDates"
                [domainModel]="domainModel"
                [showAll]="showAll"
            ></app-fcp-closing-entries>
        </app-fcp-card>
    </ng-template>

    <div class="fcp-container">
        <div class="fcp-row header-row">
            <ng-container *ngIf="navigationItems$ | async as navigationItems">
                <ham-tab-navigation
                    [navigationItems]="navigationItems$ | async"
                    [style]="'pills'"
                    [tabsTitles]="tabsTitles"
                    (tabClick)="setActiveNavigation($event)"
                ></ham-tab-navigation>
            </ng-container>
            <div class="header-actions">
                <ham-button outline="true" size="sm" icon="assets/hamIcons/eye-outline.svg" (click)="togglePreview()">
                    {{ 'aumico_reports_preview_button_text' | i18next }}</ham-button
                >

                <div class="export-menu">
                    <ham-button
                        outline="true"
                        size="sm"
                        [active]="showExportDropDown"
                        icon="assets/hamIcons/file-export-outline.svg"
                        (click)="toggleExportDropDown($event)"
                    >
                        {{ 'aumico_reports_export_button_text' | i18next }}</ham-button
                    >
                    <div
                        class="export-menu-flyout"
                        hamFlyout
                        *ngIf="showExportDropDown"
                        (closeFlyout)="toggleExportDropDown($event)"
                        [position]="menuPosition"
                        style="width: auto"
                    >
                        <ul>
                            <li (click)="exportSelection.unlabeledComments = !exportSelection.unlabeledComments">
                                <span class="ham-icon"> <i class="messages-icon"></i> </span>
                                <span class="menu-item-text">
                                    {{ 'aumico_reports_export_unlabeled_comment' | i18next }}
                                </span>
                                <span
                                    hamCheckbox
                                    [checked]="exportSelection.unlabeledComments"
                                    (change)="exportSelection.unlabeledComments = !exportSelection.unlabeledComments"
                                ></span>
                            </li>
                            <li (click)="exportSelection.internalComments = !exportSelection.internalComments">
                                <span class="ham-icon"> <i class="message-caption-icon"></i> </span>
                                <span class="menu-item-text">
                                    {{ 'aumico_reports_export_internal_comment' | i18next }}
                                </span>
                                <span
                                    hamCheckbox
                                    [checked]="exportSelection.internalComments"
                                    (change)="exportSelection.internalComments = !exportSelection.internalComments"
                                ></span>
                            </li>
                            <li (click)="exportSelection.externalComments = !exportSelection.externalComments">
                                <span class="ham-icon"> <i class="messages-icon"></i> </span
                                ><span class="menu-item-text">{{
                                    'aumico_reports_export_external_comment' | i18next
                                }}</span>
                                <span
                                    hamCheckbox
                                    [checked]="exportSelection.externalComments"
                                    (change)="exportSelection.externalComments = !exportSelection.externalComments"
                                ></span>
                            </li>
                            <li (click)="exportSelection.reviewComments = !exportSelection.reviewComments">
                                <span class="ham-icon"> <i class="search-icon"></i> </span
                                ><span class="menu-item-text">{{
                                    'aumico_reports_export_review_comment' | i18next
                                }}</span>
                                <span
                                    hamCheckbox
                                    [checked]="exportSelection.reviewComments"
                                    (change)="exportSelection.reviewComments = !exportSelection.reviewComments"
                                ></span>
                            </li>
                            <li (click)="exportSelection.pendencies = !exportSelection.pendencies">
                                <span class="ham-icon"> <i class="clock-icon"></i> </span
                                ><span class="menu-item-text">{{ 'aumico_reports_export_pendency' | i18next }}</span>
                                <span
                                    hamCheckbox
                                    [checked]="exportSelection.pendencies"
                                    (change)="exportSelection.pendencies = !exportSelection.pendencies"
                                ></span>
                            </li>
                            <li (click)="exportSelection.closing = !exportSelection.closing">
                                <span class="ham-icon"> <i class="file-check-icon"></i> </span
                                ><span class="menu-item-text">{{ 'aumico_reports_export_closing' | i18next }}</span>
                                <span
                                    hamCheckbox
                                    [checked]="exportSelection.closing"
                                    (change)="exportSelection.closing = !exportSelection.closing"
                                ></span>
                            </li>

                            <li class="spacer"></li>
                            <li (click)="exportSelection.exportExcel = !exportSelection.exportExcel">
                                <span class="ham-icon"> <i class="excel-icon"></i> </span
                                ><span class="menu-item-text">{{ 'aumico_reports_export_excel' | i18next }}</span>
                                <span
                                    hamCheckbox
                                    [checked]="exportSelection.exportExcel"
                                    (change)="exportSelection.exportExcel = !exportSelection.exportExcel"
                                ></span>
                            </li>
                            <li class="spacer"></li>
                            <li (click)="export()">
                                <span class="ham-icon"> <i class="file-export-icon"></i> </span
                                ><span class="menu-item-text">{{ 'aumico_reports_export_button_text' | i18next }}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <ham-button (click)="finalizeAndContinue()" size="sm">
                    {{ 'aumico_reports_finalize_and_continue_button' | i18next }}</ham-button
                >
            </div>
        </div>
        <div class="fcp-row content-row">
            <div class="search">
                <form [formGroup]="searchForm" (ngSubmit)="filterTestItems()">
                    <div class="form-controls">
                        <input
                            hamInput
                            icon="/assets/hamIcons/search-outline.svg"
                            formControlName="searchTerm"
                            placeholder="{{ 'aumico_reports_fcp_search_placeholder' | i18next }}"
                            (cancel)="resetFilter()"
                        />
                        <ham-button
                            size="sm"
                            icon="assets/hamIcons/search-outline.svg"
                            hideText="true"
                            (click)="filterTestItems()"
                        ></ham-button>
                    </div>
                </form>
            </div>

            <div class="test-item-nav">
                <aumico-fcp-tree
                    [treeRoot]="activeNavigationItem$ | async"
                    [showAdjustments]="showAdjustments$ | async"
                    [outputFinStatements]="outputFinStatements"
                    [inputFinStatements]="domainModel.inputFinStatements"
                    [filter]="filteredGroupOrItem"
                    [dueDateCY]="dueDateCY"
                    [dueDatePY]="dueDatePY"
                >
                </aumico-fcp-tree>
            </div>

            <div class="rightCol">
                <div class="checklist">
                    <app-fcp-card
                        *ngIf="!hasContent || (activeTestItem == null && activeTestGroupItem == null)"
                        icon="assets/hamIcons/list-outline.svg"
                        title="{{ 'aumico_reports_checklist_title' | i18next }} {{
                            (activeTestGroupItem$ | async)?.name ?? ''
                        }}"
                        [expanded]="cardExpandedState['checklist']"
                        (expandedChange)="updateCardExpandedState('checklist', $event)"
                    >
                        <app-no-content content="{{ 'aumico_reports_checklist_content' | i18next }}"></app-no-content>
                    </app-fcp-card>
                    <app-fcp-checklist
                        *ngIf="hasContent && activeTestItem == null && activeTestGroupItem != null"
                        [currentUser]="currentUser"
                        [expanded]="cardExpandedState['checklist']"
                        (expandedChange)="updateCardExpandedState('checklist', $event)"
                    ></app-fcp-checklist>
                </div>
                <div class="comments" *ngIf="!hasContent || activeTestItem == undefined">
                    <app-fcp-card
                        icon="assets/hamIcons/messages-outline.svg"
                        title="{{ 'aumico_reports_comments_title' | i18next }}"
                        [expanded]="cardExpandedState['comments']"
                        (expandedChange)="updateCardExpandedState('comments', $event)"
                    >
                        <app-no-content content="{{ 'aumico_reports_comments_content' | i18next }}"></app-no-content>
                    </app-fcp-card>
                </div>
                <div class="docs" *ngIf="!hasContent || activeTestItem == undefined">
                    <app-fcp-card
                        icon="assets/hamIcons/file-copy-outline.svg"
                        title="{{ 'aumico_reports_docs_title' | i18next }}"
                        [expanded]="cardExpandedState['docs']"
                        (expandedChange)="updateCardExpandedState('docs', $event)"
                    >
                        <app-no-content content="{{ 'aumico_reports_docs_content' | i18next }}"></app-no-content>
                    </app-fcp-card>
                </div>
            </div>

            <div class="closing" *ngIf="!hasContent || activeTestItem == undefined">
                <ng-container *ngTemplateOutlet="closingTemplate; context: { showAll: true }"></ng-container>
            </div>
            <ng-container *ngIf="hasContent && activeTestItem !== undefined">
                <div class="rightCol">
                    <div class="checklist">
                        <!--       icon="assets/hamIcons/list-outline.svg" -->
                        <app-fcp-checklist
                            [currentUser]="currentUser"
                            [expanded]="cardExpandedState['checklist']"
                            (expandedChange)="updateCardExpandedState('checklist', $event)"
                        ></app-fcp-checklist>
                    </div>

                    <div class="comments">
                        <app-fcp-card
                            icon="assets/hamIcons/messages-outline.svg"
                            title="{{ 'aumico_reports_comments_title' | i18next }}: {{ activeTestItem?.name ?? '' }}"
                            hasOtherYear="true"
                            [expanded]="cardExpandedState['comments']"
                            (expandedChange)="updateCardExpandedState('comments', $event)"
                        >
                            <app-fcp-comments [currentUser]="currentUser" [dueDates]="dueDates"> </app-fcp-comments>
                            <app-fcp-comments
                                lastYear
                                [lastYear]="true"
                                [currentUser]="currentUser"
                                [dueDates]="dueDates"
                            ></app-fcp-comments>
                        </app-fcp-card>
                    </div>
                    <div class="docs">
                        <app-fcp-card
                            hasOtherYear="true"
                            icon="assets/hamIcons/file-copy-outline.svg"
                            title="{{ 'aumico_reports_docs_title' | i18next }}: {{ activeTestItem?.name ?? '' }}"
                            [expanded]="cardExpandedState['docs']"
                            (expandedChange)="updateCardExpandedState('docs', $event)"
                        >
                            <app-fcp-documents [currentUser]="currentUser" [dueDates]="dueDates"></app-fcp-documents>
                            <app-fcp-documents
                                lastYear
                                [lastYear]="true"
                                [currentUser]="currentUser"
                                [dueDates]="dueDates"
                            ></app-fcp-documents>
                        </app-fcp-card>
                    </div>
                </div>

                <div class="closing">
                    <ng-container *ngTemplateOutlet="closingTemplate; context: { showAll: false }"></ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>
